import React, { Fragment } from "react";
import Footer from "../../Shear/Footer/Footer";
import Header from "../../Shear/Header/Header";
import Head from "../../../layout/Head";
import css from "../../../Assets/Styles/portfolio.module.css";
import PortfolioTop from "./PortfolioTop";
import PortfolioAll from "./PortfolioAll";
import ScrollToTop from "../../Shear/ScrollToTop";

const Portfolio = () => {
  return (
    <Fragment>
      <Head
        Title="Portfolio "
        href="/portfolio"
        description="IT Services Providers are companies that offer a range of IT services and solutions to help organizations manage their technology infrastructure | Portfolio Pages"
      />
      <Header />
      <section>
        <PortfolioTop css={css} />
        <PortfolioAll css={css} />
      </section>
      <ScrollToTop/>
      <Footer />
    </Fragment>
  );
};

export default Portfolio;
